<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>บทความ</span>

								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>บทความความรู้เรื่องบ้าน</span>
							</div>
							<div class="search-filter white--text">
								<span>บทความ</span>

								<div class="pl-3 pr-5">
									บทความความรู้เรื่องบ้าน
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<!-- <div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="recommend justify-center"
					no-gutters
				>
					<v-col cols="12">
						<h2 class="text-center my-7">
							บทความความรู้เรื่องบ้าน<span class="red--text">แนะนำ</span>
						</h2>

						<articleTipsCarousel
							:items="recommendList"
							white
							style="margin-bottom: 30px;"
						/>
					</v-col>
				</v-row>
			</v-container>
		</div> -->

		<div class="latest-tips bgGray py-4">
			<v-container class="pa-6">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="mx-auto"
					>
						<v-row>
							<v-col
								cols="12"
								class="pb-4"
							>
								<h2>
									<span>บทความความรู้เรื่องบ้าน</span><span class="colorRed">ล่าสุด</span>
								</h2>
							</v-col>
							<v-col
								cols="12"
								md="6"
								class="hilight px-0"
							>
								<n-link
									:to="{ name: 'article', params: { category: latestList[0].category, slug: latestList[0].slug } }"
									:title="latestList[0].title"
								>
									<z-img
										:storage="latestList[0].featured"
										:alt="latestList[0].title"
										max-width="100%"
									/>
									<div>
										<div class="article-info">
											{{ latestList[0].title }}
										</div>
										<div class="d-flex align-center">
											<v-icon
												class="mr-1"
												color="rgb(237,28,36)"
												small
											>
												mdi-clock
											</v-icon>
											{{ date(latestList[0].created_at || null) }}
										</div>
									</div>
								</n-link>
							</v-col>
							<v-col
								cols="12"
								md="6"
							>
								<v-row>
									<v-col
										v-for="(article, i) in latestList.slice(1)"
										:key="`latest-${i}`"
										cols="12"
										class="pt-0"
									>
										<n-link
											:to="{ name: 'article', params: { category: article.category, slug: article.slug } }"
											:title="article.title"
											class="article-card"
										>
											<v-card
												:elevation="$attrs.elevation || 0"
												tile
											>
												<v-row no-gutters>
													<v-col
														cols="6"
													>
														<z-img
															:storage="article.featured"
															:alt="article.title"
															max-width="100%"
														/>
													</v-col>
													<v-col
														cols="6"
														class="d-flex flex-column pl-4 pt-md-5"
													>
														<div class="article-info">
															{{ article.title }}
														</div>
														<div class="d-flex align-center">
															<v-icon
																class="mr-1"
																color="rgb(237,28,36)"
																small
															>
																mdi-clock
															</v-icon>
															{{ date(article.created_at || null) }}
														</div>
													</v-col>
												</v-row>
											</v-card>
										</n-link>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="pa-6">
				<v-row no-gutters>
					<v-col
						ref="top"
						xl="8"
						class="mx-auto"
					>
						<v-row>
							<v-col
								cols="12"
								class="pt-6 pb-4"
							>
								<h2>
									<span>บทความความรู้</span><span class="colorRed">เรื่องบ้าน</span>
								</h2>
							</v-col>
							<v-col
								v-for="(article, i) in loading ? parseInt(perPage) : list"
								:key="`${i+1}-${article.slug || i}`"
								cols="12"
							>
								<articleTipsItem
									:article="article"
									show-read-button
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'blog_review'

import { mapGetters } from 'vuex'

import articleTipsItem from '~/components/2.0/article-tips-item'
// import articleTipsCarousel from '~/components/2.0/article-tips-carousel'

export default {
	// scrollToTop: true,
	name: 'BLOGREVIEW',
	layout: 'default_2',

	components: {
		articleTipsItem,
		// articleTipsCarousel,
	},

	async asyncData(context) {
		let article = await context.app.$fireStore.collection('articles')
			.where('category', '==', 'home-knowledge')
			.where('published', '==', true)
			.orderBy('created_at', 'desc')
			// .limit(13)
			.get()

		// let recommendList = article.docs.filter((item, i) => i < 6).map(item => item.data())
		// let latestList = article.docs.filter((item, i) => i > 5 && i < 9).map(item => item.data())
		// let articleList = article.docs.filter((item, i) => i > 8).map(item => item.data())

		let latestList = article.docs.filter((item, i) => i < 3).map(item => item.data())
		let articleList = article.docs.filter((item, i) => i > 2).map(item => item.data())

		await context.store.dispatch('page/initial', {
			doc,
			fullPath: context.route.fullPath
		})

		return {
			latestList,
			articleList,
			// recommendList,
			perPage: 12,
			total: articleList.length
		}
	},

	data:() => ({
		keepAliveActivated: false,
		loading: false,
		page: 1,
		maxHeight: '100%'
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
		}),

		list () {
			return this.articleList.slice((this.page - 1) * this.perPage, this.page * this.perPage)
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},

		bannerImg () {
			return '/images/2.0/article-banner.jpg'
		},
	},

	watch: {

	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			// this.search()
		}
	},

	created() {

	},

	mounted() {

	},

	methods: {
		date (ts) {
			if (ts) {
				return new Intl.DateTimeFormat('th-TH', { dateStyle: 'long' }).format(ts.seconds * 1000)
			}

			return ''
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 155px;
		z-index: 2;

		span {
			font-size: 3em;
		}
		div {
			border-left: solid 4px #c20000;
			font-size: 2em;
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);
}
.latest-tips ::v-deep {

	.hilight {
		position: relative;

		& > a > div {
			width: 100%;
			max-width: 100%;
			position: absolute;
			bottom: 22px;
			padding: 40px 20px 20px 20px;
			color: #fff;
			background: rgb(103,103,103);
			background: linear-gradient(180deg,
				rgba(103,103,103,0.02) 0%,
				rgba(83,83,83,0.3) 15%,
				rgba(83,83,83,0.75) 40%,
				rgba(32,32,32,0.95) 100%
			);

			& {
				@media (max-width: 959px) {
					bottom: 12px;
				}
			}

			.article-info {
				font-weight: bold;
				font-size: 1.4em;
				min-height: 70px;
				max-height: 70px;
				overflow: hidden;
			}
		}
	}
	.v-responsive__sizer {
		padding-bottom: 57% !important;
	}
}
.article-card {
	font-size: 0.9rem;
	font-weight: bold;
	text-decoration: none;
	color: #000;

	.article-info {
		min-height: 70px;
    max-height: 70px;
    overflow: hidden;
	}
}

.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;
			right: unset;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
</style>
